// 表示用の数値フォーマッタ。PortWatch の貿易量は AIS 由来の「推計値」。

/** 桁区切り整数。null/NaN は "—"。 */
export function formatNumber(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return Math.round(value).toLocaleString("en-US");
}

/** 大きな数を K/M/B へ圧縮（トン数の概観用）。 */
export function formatCompact(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  const abs = Math.abs(value);
  if (abs >= 1e9) return `${(value / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${(value / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${(value / 1e3).toFixed(1)}K`;
  return String(Math.round(value));
}

/** 符号つきパーセント（前月比など）。 */
export function formatPct(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${value >= 0 ? "+" : ""}${value}%`;
}
